<template>
  <div v-once></div>
</template>
<script>
import { pleaseWait } from 'please-wait'
import 'please-wait/build/please-wait.css'

export default {
  props: ['isLoading'],
  watch: {
    isLoading: {
      handler(isLoading) {
        if (isLoading) {
          this.open()
        } else {
          this.close()
        }
      },
      immediate: true,
    }
  },
    methods: {
    open() {
      // Attaching a `pleaseWaitInstance` property (no need to declare)...
      if (!this.pleaseWaitInstance) {
        this.pleaseWaitInstance = pleaseWait({
          logo: '',  
          
          backgroundColor: '#ffffff',
          loadingHtml: `<img :src="'../../../static/images/test.png'" alt="Loading data"> <p class="loading-message">Please Wait</p>`
        })
      }
    },
    close() {
      if (this.pleaseWaitInstance) {
        this.pleaseWaitInstance.finish()
        this.pleaseWaitInstance = null
      }
    }
  },
}
</script>
<style>
.loading-message {
  color: #000000;
  font-size: 25px;
  opacity: 1;
  margin-top: 20px;
}
</style>
